import { useEffect, useMemo, useState } from "react";
import {
  APP_STATE_EVENT,
  eventTarget,
  type RtfmAppState,
  type RtfmAppStateUpdate,
} from "./rtfmAppStateShared.js";
import { WORLDS } from "@/worlds.js";
import { create } from "zustand";

export {
  dispatchAppState,
  eventTarget,
} from "./rtfmAppStateShared.js";

export type {
  ConnectionStatus,
  StreamState,
  Resolution,
  CarouselWorld,
  RtfmAppState,
  RtfmAppStateUpdate,
  SceneLoadStatus,
  SceneReference,
} from "./rtfmAppStateShared.js";

export const defaultState: RtfmAppState = {
  gatewayErrors: 0,
  connectionStatus: "connecting",
  streamState: "idle",
  viewportMode: "fit",
  resolution: { width: 256, height: 256 },
  fps: 0,
  steps: 5,
  lastFrameAt: null,
  error: null,
  queueStatus: "initial",
  queuePosition: -1,
  sceneSelectionLocked: false,
  allowSceneSelection: true,
  allowRequeue: false,
  badConnection: false,
  worldsList: WORLDS,
  currentWorldId: null,
  sceneLoadStatus: "loading",
  sceneLoadError: null,
  loadingWorldId: null,
  cursorLocked: false,
  consoleVisible: false,
};

//zustand store of state
export type RtfmAppStateStore = {
  state: RtfmAppState;  
  setState: (state: Partial<RtfmAppState>) => void;
};
export const useRtfmAppStateStore = create<RtfmAppStateStore>()((set, get) => ({
  state: defaultState,
  setState: (state: Partial<RtfmAppState>) => set({state: {...get().state, ...state}}),
}),

);
export function useRtfmAppState() {
  const {state, setState} = useRtfmAppStateStore((state) => state);

  useEffect(() => {
    const listener = (event: Event) => {
      const customEvent = event as CustomEvent<{
        kind: "state";
        payload: RtfmAppStateUpdate;
      }>;
      // console.log("useRtfmAppState", customEvent.detail.payload);
      if (customEvent.detail?.kind !== "state") {
        console.error("Received event with kind:", customEvent.detail?.kind);
        return;
      }
      setState(customEvent.detail.payload);
    };

    eventTarget.addEventListener(APP_STATE_EVENT, listener);
    return () => {
      eventTarget.removeEventListener(APP_STATE_EVENT, listener);
    };
  }, []);

  return useMemo(
    () => ({
      state,
      eventTarget,
    }),
    [state],
  );
}